import { sumBy } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import { StudentWorkbookPageDetail } from './StudentWorkbookPageDetail'

type Key = StudentWorkbookPageDetail['id']

export class StudentWorkbookPageDetailColl {
  coll: ExtendedMap<StudentWorkbookPageDetail['id'], StudentWorkbookPageDetail>

  constructor(arr: res.StudentWorkbookPageDetail[]) {
    makeAutoObservable(this)
    this.coll = ExtendedMap.fromArr(
      arr.map((data) => StudentWorkbookPageDetail.from(data)),
      'id',
    )
  }

  get toArr() {
    return this.coll.toArr
  }

  get scoredCount() {
    return sumBy(this.toArr, ({ scoring }) => (scoring.result !== 'NONE' ? 1 : 0))
  }

  get isSomeScored() {
    return this.scoredCount > 0
  }

  get isAllScored() {
    return this.scoredCount === this.toArr.length
  }

  get(key: Key) {
    return this.coll.get(key)
  }

  set(key: Key, value: StudentWorkbookPageDetail) {
    this.coll.set(key, value)
  }
}
